import { render, staticRenderFns } from "./AttachmentTable.vue?vue&type=template&id=a35e508c&"
import script from "./AttachmentTable.vue?vue&type=script&lang=js&"
export * from "./AttachmentTable.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentTable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports